import { ChevronDown, ChevronUp, FileText, TrendingUp } from "lucide-react";
import { useTran } from "@/hooks";
import { cn } from "@/lib/utils";
import { CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { getCategoryTone } from "../utils/period-constants";

/**
 * MetricCardHeader - Displays disclosure metadata and expand button
 */
const MetricCardHeader = ({
  disclosure,
  frequency,
  baseline,
  expanded,
  onToggle,
}) => {
  const { t } = useTran();
  const categoryTone = getCategoryTone(disclosure.category);

  return (
    <CardHeader className="pb-3">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="mb-2 flex flex-wrap items-center gap-2">
            <FileText className="h-4 w-4 text-muted-foreground" />
            <Badge variant="outline" className="text-xs">
              {disclosure.code}
            </Badge>
            <Badge variant="outline" className="text-xs">
              {disclosure.framework}
            </Badge>
            <Badge className={cn("text-xs", categoryTone)}>
              {disclosure.category}
            </Badge>
            {disclosure.isSubEntry ? (
              <Badge variant="outline" className="text-xs">
                {t("Sub-entry")}
              </Badge>
            ) : null}
          </div>
          <h3 className="text-base font-semibold text-foreground">
            {disclosure.title}
          </h3>
          {disclosure.isSubEntry && disclosure.subEntryTitle ? (
            <p className="mt-1 text-xs text-muted-foreground">
              → {disclosure.subEntryTitle}
            </p>
          ) : null}
          <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <TrendingUp className="h-3 w-3" />
              {t("Frequency")}:{" "}
              <span className="font-medium capitalize text-foreground">
                {frequency}
              </span>
            </span>
            <span>
              {t("Unit")}:{" "}
              <span className="font-medium text-foreground">
                {disclosure.unit || t("N/A")}
              </span>
            </span>
            <span>
              {t("Baseline")}:{" "}
              <span className="font-medium text-foreground">
                {baseline.toLocaleString()}
              </span>
            </span>
          </div>
        </div>
        <Button type="button" variant="ghost" size="sm" onClick={onToggle}>
          {expanded ? (
            <ChevronUp className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )}
        </Button>
      </div>
    </CardHeader>
  );
};

export default MetricCardHeader;
